/* eslint-disable @next/next/no-img-element */
import type { FC, ReactNode } from 'react'
import type { NavColumn } from '@/constants/navigation'

import Link from 'next/link'

import { routes } from '@/lib/routes'
import { footerColumns, socialLinks } from '@/constants/navigation'

import { PhoneSlider } from './phone-slider'

const FooterLinkList: FC<{ column: NavColumn }> = ({ column }): ReactNode => (
    <ul role='list' className='footer-list w-list-unstyled'>
        <li className='footer-list-item'>
            <div className='footer-heading'>{column.heading}</div>
        </li>
        {column.links.map(link => (
            <li key={link.label} className='footer-list-item'>
                <Link href={link.href} className='link footer-link w-inline-block'>
                    <div>{link.label}</div>
                    <div className='link-underline' />
                </Link>
            </li>
        ))}
    </ul>
)

export const Footer: FC = (): ReactNode => {
    return (
        <div className='footer'>
            <div id='Download' className='section'>
                <div className='footer-bg' />
                <div className='container'>
                    <div className='cta'>
                        <div id='w-node-_5fa0dfe7-e2ad-8858-4ebd-a7e1a5f34911-465cdbb7' className='cta-content'>
                            <div className='fade-in-on-scroll'>
                                <h2 className='cta-title'>Keep everything organized</h2>
                                <div>
                                    San Diego brings your time, expenses, and tasks together in one calm, beautifully simple
                                    workspace, so the details never slip through the cracks.
                                </div>
                            </div>
                            <div className='cta-download-buttons'>
                                <div className='download-button'>
                                    <div className='fade-in-on-scroll'>
                                        <a href='https://apple.com' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                            <img src='/images/Apple-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                            <div>
                                                {' '}
                                                <span className='hide-on-mobile'>Download </span>iOS
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className='download-button last'>
                                    <div className='fade-in-on-scroll'>
                                        <a href='https://play.google.com/store/apps' target='_blank' rel='noreferrer' className='button black-button w-inline-block'>
                                            <img src='/images/Android-Icon.svg' loading='lazy' alt='' className='download-button-icon' />
                                            <div>
                                                {' '}
                                                <span className='hide-on-mobile'>Download </span>Android
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='phone-holder-container'>
                            <PhoneSlider />
                            <img
                                src='/images/Robot-Phone.webp'
                                loading='lazy'
                                sizes='(max-width: 479px) 302px, (max-width: 767px) 590px, (max-width: 1279px) 48vw, 622px'
                                srcSet='/images/Robot-Phone-p-500.png 500w, /images/Robot-Phone-p-800.png 800w, /images/Robot-Phone-p-1080.png 1080w, /images/Robot-Phone.webp 1596w'
                                alt='San Diego app on a phone'
                                className='phone-holder-image'
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='footer-bottom-section'>
                <div className='container'>
                    <div className='footer-brand-content'>
                        <Link href={routes.home} className='footer-logo-link w-inline-block'>
                            <img src='/images/SanDiego-White.svg' alt='San Diego' className='footer-image' />
                        </Link>
                    </div>
                    <div className='footer-main-grid'>
                        <div id='w-node-e91f939a-e5bb-3bc8-6dac-f348b4e8277e-465cdbb7' className='content'>
                            <h2 className='heading-3-style'>The future of seamless living</h2>
                        </div>
                        <div id='w-node-_032a13c4-911e-7547-e8a4-5ff6abdc7474-465cdbb7' className='content'>
                            <FooterLinkList column={footerColumns[0]} />
                            <FooterLinkList column={footerColumns[1]} />
                        </div>
                        <div id='w-node-_92dc8650-5680-1780-bde0-403132dc3b7e-465cdbb7' className='content'>
                            <FooterLinkList column={footerColumns[2]} />
                        </div>
                        <div id='w-node-_7e465c43-be2e-3c8a-b963-2ab53026f47b-465cdbb7' className='content'>
                            <div className='footer-heading'>Ready for success?</div>
                            <div className='footer-main-buttons'>
                                <Link href={routes.home} className='button w-button'>
                                    Start for free
                                </Link>
                                <Link href={routes.contact} className='button button-outline w-button'>
                                    Talk to sales
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <div className='container'>
                        <div className='footer-social-media-container'>
                            <div className='fade-in-on-scroll'>
                                <div className='footer-copyright'>
                                    <div>Copyright © San Diego</div>
                                </div>
                            </div>
                            <div className='social-media-content'>
                                {socialLinks.map(social => (
                                    <a
                                        key={social.label}
                                        href={social.href}
                                        target='_blank'
                                        rel='noreferrer'
                                        className='social-media-link w-inline-block'
                                    >
                                        <img src={social.icon} loading='lazy' alt={social.label} className='social-media-icon' />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
